import {
  Button,
  Modal,
  useFetch,
  useNotificationContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback } from "react";
import { IQuickAnswerModalProps } from "./models";
import { Stack, Typography } from "@mui/material";
import { inactiveQuickAnswer } from "../../../services/quickAnswer.service";
import { useTranslation } from "react-i18next";

const translationPath = "page.settings.quickAnswer.inactive.";

export const QuickAnswerModal = memo(
  ({ open, id, onClose, onRefresh }: IQuickAnswerModalProps) => {
    const { t } = useTranslation();

    const { sendRequest, loading } = useFetch(inactiveQuickAnswer);

    const { setMessage } = useNotificationContext();

    const confirmHandler = useCallback(async () => {
      if (!id) return;

      const { success } = await sendRequest(id);
      if (success) {
        onClose();
        onRefresh();
        setMessage({
          message: t(translationPath + "success"),
          type: "success",
        });
      }
    }, [id, sendRequest, onClose, onRefresh, setMessage, t]);

    return (
      <Modal
        open={open}
        onClose={loading ? () => {} : onClose}
        title={`${t(translationPath + "title")}`}
      >
        <Typography
          sx={(t) => ({
            color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
          })}
        >
          {t(translationPath + "description")}
        </Typography>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            gap: 1,
          }}
        >
          <Button variant="text" disabled={loading} onClick={onClose}>
            {t(translationPath + "cancel")}
          </Button>
          <Button
            variant="contained"
            loading={loading}
            onClick={confirmHandler}
          >
            {t(translationPath + "confirm")}
          </Button>
        </Stack>
      </Modal>
    );
  }
);
